import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { SectionLabel } from '../components/SectionLabel';
import { SmartphoneIcon, WindIcon, BookOpenIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-14 md:py-20 px-6 bg-midnight" data-id="element-290">
      <div className="max-w-3xl mx-auto text-center" data-id="element-291">
        <FadeIn data-id="element-292">
          <SectionLabel text="Does This Sound Familiar?" data-id="element-293" />
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-warmwhite mb-10 leading-tight" data-id="element-294">
            You Already Know What Happens When Anger Takes Over.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-295">
          <div className="font-inter text-lg text-warmwhite/90 space-y-6 max-w-[680px] mx-auto text-left md:text-center" data-id="element-296">
            <p data-id="element-297">One second you're fine.</p>
            <p data-id="element-298">
              The next — your chest is tight, your jaw is clenched, and
              something inside you snaps.
            </p>
            <p data-id="element-299">You say something you regret.</p>
            <p data-id="element-300">You cry in the bathroom after.</p>
            <p data-id="element-301">You lay awake at 2AM replaying the whole thing.</p>
            <p className="pt-4 font-semibold text-rosegold" data-id="element-302">
              And the worst part?
            </p>
            <p data-id="element-303">You already tried to fix it.</p>
            <p data-id="element-304">
              You downloaded the meditation app. You took the deep breath they
              told you to take. You counted to ten.
            </p>
            <p className="italic text-lavender" data-id="element-305">
              It didn't work. Because it was never designed for the moment the
              fire actually starts.
            </p>
          </div>
        </FadeIn>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-306">
          {[{
          icon: SmartphoneIcon,
          title: 'Meditation Apps'
        }, {
          icon: WindIcon,
          title: 'Breathing Exercises'
        }, {
          icon: BookOpenIcon,
          title: 'Self-Help Books'
        }].map((item, idx) => <FadeIn key={idx} delay={0.3 + idx * 0.1} className="flex flex-col items-center" data-id="element-307">
              <div className="w-16 h-16 rounded-full bg-midnight-light border border-white/5 flex items-center justify-center mb-4" data-id="element-308">
                <item.icon className="w-8 h-8 text-lavender opacity-60" data-id="element-309" />
              </div>
              <h3 className="font-inter font-semibold text-warmwhite mb-2" data-id="element-310">
                {item.title}
              </h3>
              <p className="font-inter text-sm text-softgray line-through decoration-crimson/50 decoration-2" data-id="element-311">
                Tried it. Still angry.
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}